export const DIALOG_FORM_TYPE = {
  CLIENT: 'client',
  PROGRAM: 'program',
  PROJECT: 'project',
  PORTFOLIO: 'portfolio'
};
